import { useEffect, useState } from "react";

// Scroll progress bar — thin white line that fills as user reads.
export default function ScrollProgress() {
  const [p, setP] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const h = doc.scrollHeight - doc.clientHeight;
      setP(h > 0 ? Math.min(1, doc.scrollTop / h) : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    const onMove = (e) => {
      document.querySelectorAll(".glow-card").forEach((el) => {
        const r = el.getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
          el.style.setProperty("--gx", `${e.clientX - r.left}px`);
          el.style.setProperty("--gy", `${e.clientY - r.top}px`);
        }
      });
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] pointer-events-none"
    >
      <div
        className="h-full bg-white origin-left transition-transform duration-100 ease-out"
        style={{ transform: `scaleX(${p})` }}
      />
    </div>
  );
}
